module.exports = __webpack_public_path__ + "static/media/roopa.544bf5dc.JPG";